import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { I18nService } from '@app/i18n/i18n.service';
import { FrankliHttpErrorResponse } from '@app/models/exception/frankli-http-error-response.model';
import { SessionEventType } from '@app/models/session-log/session-event-type.model';
import { UserAPIService } from '@app/shared/api/user.api.service';
import { AuthAPIService } from '@app/shared/auth/auth.api.service';
import { Globals } from '@app/shared/globals/globals';
import { SessionLogService } from '@app/shared/session-log/session-log.service';
import { environment } from '@env/environment';
import { TranslateService } from '@ngx-translate/core';
import { Angulartics2Amplitude } from 'angulartics2/amplitude';

@Component({
  selector: 'app-magic-link',
  templateUrl: './magic-link.component.html',
  styleUrls: ['./magic-link.component.scss']
})
export class MagicLinkComponent implements OnInit {

  private magicLinkToken : string;
  constructor(
    public route: ActivatedRoute,
    private authService: AuthAPIService,
    private translateService: TranslateService,
    private angulartics2Amplitude: Angulartics2Amplitude,
    private sessionLogService: SessionLogService,
    private router: Router,
    public globals: Globals, 
    private i18nService: I18nService,
    private userAPIService: UserAPIService
  ) { }




  ngOnInit(): void {
    this.magicLinkToken = this.route.snapshot.paramMap.get('token');

    this.authService.authenticateMagicLink(this.magicLinkToken)
      .toPromise()
      .then(userInit => {
        console.info("magic link: ", userInit);
        localStorage.setItem('access_token', userInit.accessToken);
        this.globals.init(userInit);
        
        this.globals.welcomeViewed = false;
        this.i18nService.language = this.globals.user.configuration.preferredLocale;
        this.sessionLogService.log(SessionEventType.SESSION_START_LOGIN);

        if (environment.production) {
          this.angulartics2Amplitude.setUsername(this.globals.user.email);
        }

        this.userAPIService.setTimezone(this.globals.user).subscribe(
          (user) => {
            this.globals.updateUser(user);
            this.router.navigateByUrl('/');
          }
        );
      })
      .catch((error: FrankliHttpErrorResponse) => {
        this.handleError(error.error.message);
      });
  }

  private handleError(message: string) {
    localStorage.setItem('sso_error', `${Date.now()}: ${message}`);
    this.router.navigateByUrl('/');
  }

}
